import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { WordPressService } from '../../services/word-press.service';
import { LoadingSpinnerComponent } from '../custom/loading-spinner/loading-spinner.component';

import { MatIconModule } from '@angular/material/icon';
import { SafePipe } from '../../pipes/safe.pipe';
import { HtmlDecodePipe } from '../../pipes/html-decode.pipe';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-johnstons-daily-page',
  imports: [
    LoadingSpinnerComponent,
    MatIconModule,
    MatCardModule,
    SafePipe,
    HtmlDecodePipe,
    MatRippleModule,
    RouterModule,
    MatBadgeModule,
    CommonModule,
  ],
  templateUrl: './johnstons-daily-page.component.html',
  styleUrl: './johnstons-daily-page.component.css',
})
export class JohnstonsDailyPageComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  wordpressService = inject(WordPressService);
  posts = computed(() => this.wordpressService.posts());
  isLoading = computed(() => this.wordpressService.isLoading());
  error = computed(() => this.wordpressService.error());

  readDaily = computed(() => this.wordpressService.readDaily());

  postLink = signal<string | null>(null);

  @ViewChild('blogFrame') blogFrame!: ElementRef;

  ngOnInit(): void {
    // make iframe full width
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  selectPost(link: string | null) {
    this.postLink.set(link);
    this.wordpressService.setDaily(true);
  }

  ngAfterViewInit() {
    // Add event listener for messages from the iframe
    window.addEventListener('message', this.handleIframeMessage.bind(this));
  }

  onIframeLoad() {
    // Attempt to send resize message to iframe content
    try {
      const frame = this.blogFrame.nativeElement;
      frame.contentWindow.postMessage('requestHeight', '*');
    } catch (e) {
      console.warn('Could not send message to iframe:', e);
    }
  }

  private handleResize() {
    // Update iframe dimensions if needed
    const frame = this.blogFrame.nativeElement;
    frame.style.height = `${window.innerHeight}px`;
  }

  private handleIframeMessage(event: MessageEvent) {
    // Handle messages from the iframe content
    if (event.data && event.data.type === 'setHeight') {
      const frame = this.blogFrame.nativeElement;
      frame.style.height = `${event.data.height}px`;
    }
  }

  ngOnDestroy() {
    // Clean up event listeners
    window.removeEventListener('resize', this.handleResize.bind(this));
    window.removeEventListener('message', this.handleIframeMessage.bind(this));
  }
}
